import { useRef } from "react";
import { motion, useScroll, useSpring } from "framer-motion";
import { Reveal } from "@/components/brand";
import { processSteps } from "@/lib/offer";

export default function Process() {
  const listRef = useRef(null);
  const { scrollYProgress } = useScroll({ target: listRef, offset: ["start 75%", "end 55%"] });
  const progress = useSpring(scrollYProgress, { stiffness: 120, damping: 24, restDelta: 0.001 });

  return (
    <section id="processo" data-testid="process-section" className="py-20 md:py-28">
      <div className="mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
        <Reveal>
          <h2 className="text-3xl font-bold tracking-[-0.03em] text-foreground md:text-5xl">
            Do primeiro oi ao site no ar
          </h2>
        </Reveal>

        <div ref={listRef} className="relative mt-12">
          <div aria-hidden="true" className="absolute bottom-0 left-0 top-0 w-0.5 bg-border">
            <motion.div style={{ scaleY: progress }} className="h-full w-full origin-top bg-primary" />
          </div>

          <ol className="border-t border-border pl-6 md:pl-8">
            {processSteps.map((step, i) => (
              <Reveal
                key={step.title}
                as="li"
                delay={i * 0.08}
                className="grid gap-2 border-b border-border py-8 md:grid-cols-[3rem_minmax(0,2fr)_minmax(0,3fr)] md:gap-6"
              >
                <span aria-hidden="true" className="text-3xl font-bold tracking-[-0.04em] text-primary">
                  {i + 1}
                  <span className="text-accent">.</span>
                </span>
                <h3
                  data-testid={`process-step-${i}`}
                  className="text-xl font-semibold tracking-[-0.02em] text-foreground md:pt-1.5"
                >
                  {step.title}
                </h3>
                <p className="leading-relaxed text-muted-foreground md:pt-2">{step.description}</p>
              </Reveal>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
